"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgMale = function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24 2.19a.76.76 0 1 1 1.52 0 .76.76 0 0 1-1.52 0zM4 .43a1.76 1.76 0 0 0-.46 3.46h-.12c-.895.007-1.578.309-2.061.823-.47.499-.71 1.153-.827 1.797C.3 7.791.526 9.222.665 9.922l.981-.194c-.135-.68-.326-1.955-.13-3.04.097-.539.282-.983.57-1.29.275-.292.686-.503 1.34-.509h1.147c.655.006 1.065.217 1.34.51.289.306.474.75.57 1.289.197 1.085.005 2.36-.13 3.04l.981.194c.14-.7.365-2.13.134-3.412-.116-.644-.357-1.298-.827-1.797-.484-.514-1.166-.816-2.061-.824h-.121A1.76 1.76 0 0 0 4 .43zM1.963 6.32c-.22 3.163-.334 5.079.278 8.643l.072.415h3.374l.072-.415c.611-3.563.509-5.479.289-8.643l-.998.07c.21 3.005.307 4.805-.208 7.988H4.5V10.34h-1v4.037h-.342c-.514-3.182-.407-4.981-.198-7.989l-.997-.069z",
    fill: "#4D4D4D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgMale);
var _default = exports["default"] = Memo;